module.exports = __webpack_public_path__ + "img/组 264.e0561f9c.png";